import React from "react";

const xd = () => {
  return (
    <header>
      <div className="links">
        <a>About Page</a>
        <a>About Me </a>
      </div>
      <div className="texto">
        <div className="empty"></div>
        <div className="full" id="header-text">
          La mayoría de las personas buscamos a la persona ideal para pasar
          nuestras vidas, no existe, solo existe la persona correcta que
          soportaría la idea de pasar mucho tiempo con nosotros
        </div>
      </div>
    </header>
  );
};

export default xd;
